import React, { useEffect, useState, useRef } from 'react';
import ContactModal from './ContactModal';

/**
 * Pulsante di contatto intelligente che cambia posizione in base alla visibilità
 * della partner bar:
 * - Quando la partner bar è visibile: appare sotto il terminale nella hero
 * - Quando la partner bar non è visibile: diventa floating in basso a destra
 */
const ContactButton = () => {
  const [isHeroContentVisible, setIsHeroContentVisible] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const buttonRef = useRef(null);
  
  useEffect(() => {
    // Trova la partner bar
    const heroContent = document.querySelector('.hero-content');
    if (!heroContent) return;

    const observer = new IntersectionObserver((entries) => {
      // Aggiorna lo stato in base alla visibilità della partner bar
      setIsHeroContentVisible(entries[0].isIntersecting);
    }, {
      threshold: 0.1, // Basta che sia visibile un minimo
      rootMargin: '0px 0px 0px 0px' // Margine aggiuntivo
    });
    
    // Inizia a osservare la partner bar
    observer.observe(heroContent);
    
    return () => observer.disconnect();
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  return (
    <>
      <button
        onClick={handleClick}
        className={`contact-button ${isHeroContentVisible ? 'in-hero' : 'floating'}`}
        ref={buttonRef}
      >
        Contattaci
      </button>
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default ContactButton;